<template>
    <div class="rd-sidebar">
        <DesktopNavigation v-if="device !== 'mobile'" @redeem="$refs.RedemptionCodePopup.open()" />
        <div v-else class="Opend">
            <div class="Opend_top">
                <div class="Opend_top_inset">
                    <div v-if="device !== 'mobile'" class="share_box" @click="onMenuItem('Affiliate')">
                        <div class="share_inset">
                            <img src="@/assets/mobile-home/ui/affiliate.svg" />
                            <div>{{ $t("person.InvitationCenter") }}</div>
                        </div>
                    </div>
                    <div v-if="device === 'mobile' && isLogin" class="user_info flex">
                        <div class="avatar-wrap">
                            <div class="flex avatar"><img src="@/assets/person/avatar.png" alt="">
                            </div>
                        </div>
                        <div class="user-info">
                            <p class="user-name">Hi, {{ userPhone }}</p>
                            <div class="user-code flex-start" @click="copyText(userInfo.id)">
                                <p>ID: {{ userInfo.id }}</p>
                                <img :src="$themeImage('sidebar.copy')" alt="">
                            </div>
                        </div>
                    </div>
                    <div v-if="device === 'mobile' && !isLogin" class="login-wrap">
                        <div class="sign_up" @click="toLogin(1)">{{ $t("login.SignUp") }}</div>
                        <div class="login_btn" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                    <div class="vip_box" v-if="userInfo && vipList.length && isLogin" @click="onMenuItem('vip', true)">
                        <div class="vip_img">
                            <img :src="$themeImage('sidebar.vipBadge')" />
                            <div class="vip_level">
                                <div>VIP {{ userInfo.levelDetailVo.memberLevelCode || 0 }}</div>
                            </div>
                        </div>
                        <div class="vip_info">
                            <div class="vip_progress">
                                <div class="rate">{{ $t('Vip.RechargeAmount') }}: <span>{{ formatAmount(userInfo.levelDetailVo.currentAmtRecharge || 0) }}/{{ formatAmount(nextVipItem.amtRecharge || 0) }}</span></div>
                                <lineProgress :progress="userInfo.rechargeProgress" :height="0.13"></lineProgress>
                                <div class="rate">{{ $t('Vip.BetAmount') }}: <span>{{ formatAmount(userInfo.levelDetailVo.currentAmtOrder || 0) }}/{{ formatAmount(nextVipItem.amtOrder || 0) }}</span></div>
                                <lineProgress :progress="userInfo.betProgress" :height="0.13"></lineProgress>
                            </div>
                        </div>
                    </div>
                    <div v-if="device === 'mobile'" class="search_btn" @click.stop="toSearch">
                        <i class="iconfont icon-sousuo"></i>
                        <div class="txt"> {{ $t("home.SearchGames") }}</div>
                    </div>
                    <div v-if="device === 'mobile'" class="share_box share_box_mobile" @click="onMenuItem('Affiliate')">
                        <div class="share_inset">
                            <img src="@/assets/mobile-home/ui/affiliate.svg" />
                            <div>{{ $t("person.InvitationCenter") }}</div>
                        </div>
                    </div>
                    <div v-if="showThemeSkinSelect" class="theme_select" @click.stop>
                        <label for="sidebar-theme-select">{{ $t('displayUi.appearance') }}</label>
                        <div class="theme_select_box">
                            <select id="sidebar-theme-select" :value="themeSkin" @change="onThemeSkinChange">
                                <option v-for="item in themeSkinOptions" :key="item.value" :value="item.value">
                                    {{ item.value === 'purple' ? $t('displayUi.charcoalCoral') : item.label }}
                                </option>
                            </select>
                            <i class="iconfont icon-xiangyou"></i>
                        </div>
                    </div>
                    <!-- <div class="red_packet_test" @click="playRedPacketRain">
                        红包雨测试
                    </div> -->
                    <div v-if="device !== 'mobile' && isLogin" class="userMoneyInfo">
                        <div class="align-center" @click="getUserInfo">
                            <div class="d-flex moneyLabel">
                                <span>{{ $t("person.Balance") }}</span>
                                <img :class="{ 'turning': isRefreshingMoney }" :src="$themeImage('sidebar.refresh')" />
                            </div>
                            <div class="moneyInfo">{{ CurrencyType }}{{ allBalance }}</div>
                        </div>
                        <div class="userMoneyAdd" @click="onNavTo({ url: '/wallet' })">
                            <div>{{ $t("login.Account") }}</div>
                            <img :src="$themeImage('sidebar.pathArrow')" />
                        </div>
                    </div>
                    <div class="menu-group">
                        <div class="menu-item" :class="{ 'act': pathAct == 'Event' }" @click="onMenuItem('Event')">
                            <div class="icon">
                                <!-- <van-icon name="pending-payment" /> -->
                                <img class="imgAct" src="@/assets/mobile-home/ui/redeem.svg" alt="">
                                <img src="@/assets/mobile-home/ui/redeem.svg" alt="">
                            </div>
                            <div>{{ $t("person.Promotion") }}</div>
                            <div class="upto-rate-wrap">
                                <!-- <div class="upto-numb">20%</div> -->
                                <div class="arrow"></div>
                            </div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'vip' }" @click="onMenuItem('vip', true)">
                            <div class="icon">
                                <!-- <van-icon name="diamond-o" /> -->
                                <img class="imgAct" src="@/assets/mobile-home/ui/vip.svg" alt="">
                                <img src="@/assets/mobile-home/ui/vip.svg" alt="">
                            </div>
                            <div>{{ $t("person.VIPClub") }}</div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'Affiliate' }" @click="onMenuItem('Affiliate')">
                            <div class="icon">
                                <!-- <van-icon name="friends-o" /> -->
                                <img class="imgAct" src="@/assets/mobile-home/ui/affiliate.svg" alt="">
                                <img src="@/assets/mobile-home/ui/affiliate.svg" alt="">
                            </div>
                            <div>{{ $t("tabbar.Affiliate") }}</div>
                            <img class="icon_hot" :src="$themeImage('common.hot')">
                        </div>
                        <div class="menu-item" @click="$refs.RedemptionCodePopup.open()">
                            <div class="icon">
                                <!-- <van-icon name="coupon-o" /> -->
                                <img class="imgAct" src="@/assets/mobile-home/ui/redeem.svg" alt="">
                                <img src="@/assets/mobile-home/ui/redeem.svg" alt="">
                            </div>
                            <div>{{ $t("RedemptionCode.RedemptionCode") }}</div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'JoinChannel' }"
                            @click="onMenuItem('JoinChannel')">
                            <div class="icon">
                                <!-- <van-icon name="service-o" /> -->
                                <!-- <van-icon name="chat-o" /> -->
                                <svg class="rd-social-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8 12 9-7M8 13l9 6M8 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0M22 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0M22 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0" /></svg>
                            </div>
                            <div>{{ $t("socialMedia.socialMedia") }}</div>
                        </div>
                        <button type="button" class="menu-item sidebar-download" @click.stop="handleClickOutside(); $store.dispatch('user/setIsShowDownAppPopup', true)">
                            <span class="icon"><RefreshIcon name="download"/></span>
                            <span>{{ $t('refresh.downloadTitle') }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="Opend_bottom">
                <div class="sidebar_icons">
                    <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon"
                        @click="onNavTo({ url: item.url, type: 'href' })" />
                </div>
                <div class="sidebar_lang" @click.stop="$refs.language.onShowLangPopup()">
                    <language ref="language" :show="true" :showIcon="true">
                        <template #langType>
                            <div class="sidebar_lang_box">
                                <div class="sidebar_lang_txt">{{ langName }}</div>
                                <img v-if="DisabledBelongCountry !== 'disable'" :src="$themeImage('sidebar.languageArrow')" />
                            </div>
                        </template>
                    </language>
                </div>
                <div class="sidebar_customerService" @click.stop="onMenuItem('notification')">
                    <div>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 14v-3a9 9 0 0 1 18 0v3M3 12H2v7h4v-7H3Zm18 0h1v7h-4v-7h3ZM19 19a4 4 0 0 1-4 4h-3" /></svg>
                        {{ $t("person.LiveChat") }} 24/7
                    </div>
                </div>
            </div>
        </div>
        <div class="Sidebar-close-icon" @click="handleClickOutside">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                class="icon-base_root-F1flk icon-base_m-F1flk" width="24" height="24" data-icon="close">
                <path fill-rule="evenodd"
                    d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                    clip-rule="evenodd"></path>
            </svg>
        </div>
        <RedemptionCodePopup ref="RedemptionCodePopup"></RedemptionCodePopup>
        <RedPacketRain ref="RedPacketRain"></RedPacketRain>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import language from '@/components/language'
import RedemptionCodePopup from '@/components/RedemptionCodePopup'
import RedPacketRain from '@/components/RedPacketRain'
import { domainKey, showThemeSkinSelect } from '@/common/http'
import { themes } from '@/themes'
import { getListLevel, getUserInfo } from '@/api/user'
import lineProgress from '@/components/lineProgress'
import DesktopNavigation from '@/components/desktop/DesktopNavigation.vue'

const themeSkinLabels = {
    crimson: '深红 crimson',
    emerald: '祖母绿 emerald',
    green: 'Green #28cb00',
    blue: '蓝色 blue',
    iceblue: '冰蓝 iceblue',
    porcelain: '蓝白 porcelain',
    purple: '炭黑珊瑚'
}

export default {
    name: 'Sidebar',
    components: { language, RedemptionCodePopup, RedPacketRain, lineProgress, DesktopNavigation },
    data() {
        return {
            domainKey,
            activeEventId: '',
            act: 0,
            hoverAct: 0,
            hoverActTemp: 0,
            isHover: false,
            subAct: 0,
            isShowSub: false,
            PCSubMenus: [],
            pathAct: '',
            platforms: [],
            showPlatformsPopover: false,
            isRefreshingMoney: false,
            userInfo: {
                levelDetailVo: {
                    memberLevelIcon: '',
                    currentAmtRecharge: 0,
                    currentAmtOrder: 0,
                    memberLevelCode: 0
                }
            },
            nextVipItem: {},
            vipList: [],
            showThemeSkinSelect,
            themeSkinOptions: Object.keys(themes).map((value) => ({
                value,
                label: themeSkinLabels[value] || value
            }))
        }
    },
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device
        }),
        mobile() {
            return this.device === 'mobile'
        },
        isLogin() {
            return !!this.$store.getters.token
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        isCollapse() {
            return !this.sidebar.opened
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        langName() {
            const type = this.$store.getters.language
            return this.langObj[type].name
        },
        themeSkin() {
            return this.$store.getters.themeSkin
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.act = ''
                this.subAct = ''
                const opt = this.$route?.params
                if (opt && opt.params) {
                    const params = JSON.parse(decodeURIComponent(opt?.params))
                    this.act = params?.code
                    if (params.gameTitleId) this.subAct = params.gameTitleId
                }
                this.pathAct = this.$route.name
            },
            deep: true
        },
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        },
        themeSkin() {
            this.GetPlatforms()
        }
    },
    created() {
        if (this.isLogin) {
            this.getUserInfo()
            // if (this.device !== 'mobile') this.getUserInfo()
            // else this.userInfo = this.$store.getters.userInfo
        }
        this.act = ''
        this.subAct = ''
        const opt = this.$route?.params
        if (opt && opt.params) {
            const params = JSON.parse(decodeURIComponent(opt?.params))
            this.act = params?.code
            if (params.gameTitleId) this.subAct = params.gameTitleId
        }
        this.pathAct = this.$route.name
    },
    methods: {
        getUserInfo() {
            const that = this
            that.isRefreshingMoney = true
            that.$forceUpdate()
            getUserInfo().then((res) => {
                if (res?.code !== 0 || !res.result) return
                const D = res.result
                that.userInfo = D
                if (!that.vipList.length) that.getListLevel()
            }).finally(() => {
                that.isRefreshingMoney = false
                that.$forceUpdate()
            })
        },
        getListLevel() {
            const that = this
            getListLevel().then((res) => {
                const vipList = res?.code === 0 && Array.isArray(res.result) ? res.result.filter(Boolean) : []
                that.vipList = vipList
                if (vipList.length && that.userInfo?.levelDetailVo) {
                    const nextLevel = that.userInfo.levelDetailVo.memberLevelCode + 1
                    that.nextVipItem = vipList[nextLevel] || vipList[vipList.length - 1]
                    that.userInfo.rechargeProgress = (that.userInfo.levelDetailVo.currentAmtRecharge / that.nextVipItem.amtRecharge) * 100
                    that.userInfo.betProgress = (that.userInfo.levelDetailVo.currentAmtOrder / that.nextVipItem.amtOrder) * 100
                    if (that.userInfo.rechargeProgress > 100) {
                        that.userInfo.rechargeProgress = 100
                    }
                    if (that.userInfo.betProgress > 100) {
                        that.userInfo.betProgress = 100
                    }
                    if (that.userInfo.levelDetailVo.currentAmtRecharge === 0) {
                        that.userInfo.rechargeProgress = 0
                    }
                    if (that.userInfo.levelDetailVo.currentAmtOrder === 0) {
                        that.userInfo.betProgress = 0
                    }
                    that.userInfo.rechargeDistance = that.nextVipItem.amtRecharge - that.userInfo.levelDetailVo.currentAmtRecharge
                    that.userInfo.betDistance = that.nextVipItem.amtOrder - that.userInfo.levelDetailVo.currentAmtOrder
                }
            })
        },
        onMenuItem(act, isLogin) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            if (isLogin) {
                this.onNavToByIsLogin({ url: act, type: 'post' })
            } else {
                this.onNavTo({ url: act, type: 'post' })
            }
        },
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        toLogin(type) {
            if (this.isLogin) {
                this.$store.dispatch('user/setIsShowMyProfilePopup', true)
            } else {
                this.$store.dispatch('user/changeLoginType', type)
                this.$store.dispatch('user/setIsShowLoginPopup', true)
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            // const facebook = systemConfig.facebook?.trim()
            // if (facebook) {
            //     const platform1 = {
            //         id: 0,
            //         icon: this.$themeImage('share.iconFacebook'),
            //         title: 'Facebook',
            //         url: facebook,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform1)
            // }
            // const telegram = systemConfig.telegram?.trim()
            // if (telegram) {
            //     const platform2 = {
            //         id: 1,
            //         icon: this.$themeImage('share.iconTelegram'),
            //         title: 'Telegram',
            //         url: telegram,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform2)
            // }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: this.$themeImage('share.iconTelegram'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: this.$themeImage('share.iconInstagram'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
            // const youTube = systemConfig.youTube?.trim()
            // if (youTube) {
            //     const platform4 = {
            //         id: 3,
            //         icon: this.$themeImage('share.iconYoutube'),
            //         title: 'Youtube',
            //         url: youTube,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform4)
            // }
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: this.$themeImage('share.iconWhatsapp'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            // const twitter = systemConfig.twitter?.trim()
            // if (twitter) {
            //     const platform6 = {
            //         id: 5,
            //         icon: this.$themeImage('share.iconX'),
            //         title: 'X',
            //         url: twitter,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform6)
            // }
            // const tiktok = systemConfig.tiktok?.trim()
            // if (tiktok) {
            //     const platform7 = {
            //         id: 6,
            //         icon: this.$themeImage('share.iconTiktok'),
            //         title: 'TikTok',
            //         url: tiktok,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform7)
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        onThemeSkinChange(event) {
            const nextThemeSkin = event.target.value
            if (nextThemeSkin && nextThemeSkin !== this.themeSkin) {
                this.$setThemeSkin(nextThemeSkin)
            }
        },
        playRedPacketRain() {
            this.$refs.RedPacketRain.play()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.Sidebar-close-icon {
    position: absolute;
    background: var(--theme-header-control-bg);
    border: .01rem solid var(--theme-sidebar-control-border);
    width: .68rem;
    height: .68rem;
    top: .38rem;
    right: -.88rem;
    border-radius: .12rem;
    align-items: center;
    justify-content: center;
    font-size: .34rem;
    display: none;
    cursor: pointer;

    svg {
        fill: $font-title-color;
    }
}

.Opend {
    display: block;
    height: 100%;
    box-sizing: border-box;
    padding-right: 0;
    overflow: auto;
    width: 300px;
    position: relative;
    z-index: 2;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;
    background-image: var(--theme-sidebar-bg);
    background-size: var(--theme-sidebar-bg-size);
    background-position: bottom right, center center;
    background-repeat: no-repeat;

    &::-webkit-scrollbar {
        display: none;
    }
}

.Opend_top {
    flex: 1;
    width: 100%;
    position: relative;

    .Opend_top_inset {
        &::-webkit-scrollbar {
            display: none;
        }

        .flex {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .flex-start {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }

        .user_info {
            height: 1.8rem;
            margin: .38rem .22rem .2rem;
            justify-content: center;
            border-radius: .3rem;
            padding: .2rem 0;
            position: relative;
            overflow: visible;

            .avatar-wrap {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;

                .avatar {
                    width: 1.3rem;
                    height: 1.3rem;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        pointer-events: none;
                        vertical-align: bottom;
                    }
                }
            }

            .user-info {
                flex: 0 1 100%;
                text-align: left;
                margin-left: .1rem;

                .user-name {
                    font-size: .3rem;
                    font-weight: 500;
                    padding-right: .15rem;
                    margin-right: .15rem;
                    margin-bottom: .1rem;
                    color: var(--theme-bright-text) !important;
                }

                .user-code {
                    p {
                        color: var(--theme-soft-text);
                        font-weight: 500;
                        margin: 0;
                    }

                    img {
                        width: .28rem;
                        height: .28rem;
                        margin-left: .1rem;
                    }
                }
            }
        }

        .login-wrap {
            // width: 100%;
            position: relative;
            display: flex;
            justify-content: space-between;
            margin: .3rem .22rem .4rem;

            &>div {
                width: 2rem;
                flex: 0 1 49%;
                height: .8rem;
                border-radius: .16rem;
                padding: 0 .1rem;
                font-size: .28rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &.sign_up {
                    background: var(--theme-header-accent-bg);
                    color: var(--theme-active-text);
                    margin-right: .15rem;
                }

                &.login_btn {
                    border: .01rem solid var(--theme-sidebar-control-border);
                    background: var(--theme-header-control-bg);
                    color: var(--theme-bright-text);
                }
            }
        }
    }
}

.Opend_bottom {
    position: relative;
    margin: .08rem .42rem;
    margin-top: 0;
    margin-left: .28rem;
    padding: .4rem 0;
    padding-right: .08rem;
    border-top: .01rem solid var(--theme-sidebar-border);

    .sidebar_icons {
        display: flex;
        align-items: center;

        &>img {
            cursor: pointer;
            width: .78rem;
            height: .78rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: .22rem;
        }
    }

    .sidebar_customerService {
        width: 100%;
        position: relative;

        &>div {
            display: flex;
            align-items: center;
            width: 100%;
            font-size: .3rem;
            border-radius: .2rem;
            height: 1.2rem;
            background: var(--theme-sidebar-service-bg);
            border: 1px solid transparent;
            background-clip: padding-box;
            /* 用伪元素实现渐变边框（支持圆角） */
            position: relative;
            z-index: 1;
            color: $font-title-color;
            padding-left: .3rem;

            &>img {
                width: .68rem;
                height: .68rem;
                vertical-align: middle;
                margin-right: .16rem;
            }
        }

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: -1;
            border-radius: .2rem;
            /* 娴ｇ姷娈戝〒鎰綁鏉堣顢嬫０婊嗗 */
            background: var(--theme-sidebar-item-active-line);
        }
    }

    .sidebar_lang {
        display: flex;
        align-items: center;
        background: var(--theme-sidebar-control-bg);
        border: .01rem solid var(--theme-sidebar-control-border);
        height: .88rem;
        padding: 0 .24rem;
        width: 100%;
        border-radius: .24rem;
        cursor: pointer;
        margin: .28rem 0;

        .sidebar_lang_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: calc(100% - .46rem);

            .sidebar_lang_txt {
                margin: 0 .12rem;
                color: $font-title-color;
                font-size: .25rem;
            }

            img {
                width: .38rem;
                height: .38rem;
                vertical-align: middle;
            }
        }
    }
}

.share_box {
    width: 100%;
    min-height: 1.35rem;
    margin: .2rem .22rem .32rem;
    width: calc(100% - .44rem);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(242, 185, 157, .38);
    border-radius: .18rem;
    background: linear-gradient(135deg, rgba(242, 185, 157, .12), rgba(242, 185, 157, .02) 44%), linear-gradient(180deg, #302d30, #1b1a1c);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .08), 0 .12rem .28rem rgba(0, 0, 0, .28);

    &::after {
        content: '';
        position: absolute;
        inset: auto .18rem .13rem .18rem;
        height: .03rem;
        border-radius: .03rem;
        background: linear-gradient(90deg, transparent, var(--theme-input-focus-border), transparent);
        opacity: .72;
    }

    .share_inset {
        position: absolute;
        inset: 0 .22rem;
        display: flex;
        align-items: center;

        &>div {
            display: block;
            margin-left: 8px;
            position: relative;
            z-index: 1;
            text-align: left;
            color: $font-title-color;
            font-size: 16px;
            font-weight: 600;
        }

        &>img {
            width: 50px;
            height: 50px;
            vertical-align: middle;
            margin-bottom: 6px;
        }
    }

    &.share_box_mobile{
        margin: .18rem .22rem .28rem;
        position: relative;
        z-index: 1;

        .share_inset {
            inset: 0 .22rem;

            &>div {
                margin-left: .1rem;
                font-size: .3rem;
            }

            &>img {
                width: .88rem;
                height: .88rem;
                margin-bottom: .1rem;
            }
        }
    }
}

.vip_box {
    margin-bottom: .4rem;
    cursor: pointer;
    position: relative;
    padding: 0 .3rem;

    .vip_img {
        position: relative;
        padding-left: .3rem;

        img {
            width: .48rem;
            height: .48rem;
            vertical-align: middle;
            object-fit: contain;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 3;
        }

        .vip_level {
            width: 1.3rem;
            text-align: center;
            font-size: .24rem;
            padding: .06rem 0;
            color: $font-title-color;
            background: var(--theme-header-accent-bg);
            line-height: 1;
            transform: skewX(160deg);

            &>div {
                transform: skewX(-160deg);
            }
        }
    }

    .vip_info {
        flex: 1;
        display: flex;
        align-items: flex-start;
        margin: 0;
        padding-top: .02rem;

        .vip_progress {
            flex: 1;
            padding-right: .04rem;

            &:last-child {
                font-size: .2rem;

                .rate {
                    font-size: .22rem;
                    color: var(--theme-bright-text);
                    margin: .02rem 0 .06rem;
                    line-height: 1.15;
                    text-align: right;
                    padding-top: .1rem;

                    &>span {
                        color: var(--theme-soft-text);
                    }
                }
            }
        }
    }
}

.userMoneyInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: .2rem;
    margin-top: 0;
    height: 64px;

    .align-center {
        // flex: 1;
        width: calc(100% - 90px);
        padding: .1rem .2rem;
        background: var(--theme-surface-bg);
        height: 100%;
        box-sizing: border-box;
        vertical-align: middle;
    }

    .moneyLabel {
        color: var(--theme-bright-text);
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-left: 6px;

            &.turning {
                animation: rotateAni 0.2s linear infinite;
            }

            @keyframes rotateAni {
                0% {
                    transform: rotate(0deg);
                }

                100% {
                    transform: rotate(-360deg);
                }
            }
        }
    }

    .userMoneyAdd {
        width: 90px;
        height: 100%;
        background: var(--theme-header-accent-bg);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        text-transform: capitalize;
        color: var(--theme-bright-text);
        box-sizing: border-box;

        & > img{
            height: 6px;
            width: auto;
            vertical-align: middle;
            margin-top: 8px;
        }
    }

    .moneyInfo {
        color: var(--theme-popup-amount-text);
        text-align: left;
        font-size: 22px;
    }
}

.search_btn {
    border-radius: .14rem;
    background: var(--theme-header-control-bg);
    border: 1px solid var(--theme-header-control-border);
    margin: .25rem .22rem;
    padding: .15rem .28rem;
    display: flex;
    align-items: center;
    cursor: pointer;

    .txt {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: .26rem;
        color: var(--theme-input-placeholder);
    }

    .iconfont {
        color: var(--theme-input-placeholder);
        font-weight: bold;
        margin-right: .22rem;
    }
}

.theme_select {
    width: calc(100% - .44rem);
    min-height: .72rem;
    margin: .12rem .22rem .24rem;
    padding: .08rem .12rem .08rem .18rem;
    border: .01rem solid var(--theme-sidebar-control-border);
    border-radius: .18rem;
    background: var(--theme-sidebar-control-bg);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .12);

    label {
        font-size: .24rem;
        font-weight: 700;
        color: var(--theme-soft-text);
        white-space: nowrap;
    }

    .theme_select_box {
        position: relative;
        min-width: 1.68rem;
        height: .52rem;
        display: flex;
        align-items: center;
        border-radius: .14rem;
        background: var(--theme-active-bg);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, .2), 0 .04rem .1rem rgba(0, 0, 0, .16);
        overflow: hidden;

        select {
            width: 100%;
            height: 100%;
            padding: 0 .48rem 0 .18rem;
            border: 0;
            outline: 0;
            background: transparent;
            color: var(--theme-active-text);
            font-size: .24rem;
            font-weight: 700;
            appearance: none;
            -webkit-appearance: none;
            cursor: pointer;

            option {
                color: #0b2148;
                background: #ffffff;
            }
        }

        .iconfont {
            position: absolute;
            right: .14rem;
            top: 50%;
            color: var(--theme-active-text);
            font-size: .22rem;
            transform: translateY(-50%) rotate(90deg);
            pointer-events: none;
        }
    }
}

.red_packet_test {
    margin: .18rem .24rem .08rem;
    height: .72rem;
    border-radius: .18rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: .26rem;
    font-weight: 700;
    color: var(--theme-active-text);
    background: linear-gradient(180deg, #ffdf53 0%, #ff9a1b 100%);
    box-shadow: 0 .08rem .16rem rgba(0, 0, 0, .22);
}

.sidebar-download {
    text-align: left;

    &:focus-visible {
        outline: 2px solid #ff6055;
        outline-offset: 2px;
    }
}

.menu-group {
    background-color: transparent !important;
    padding: 12px 12px !important;
    position: relative;
    z-index: 2;
}

.menu-item {
    width: 100%;
    height: 52px;
    display: flex;
    align-items: center;
    font-size: 15px;
    position: relative;
    cursor: pointer;
    margin-bottom: 10px;
    color: var(--theme-sidebar-item-text);
    margin-left: .12rem;

    .icon_hot {
        object-fit: contain;
        width: 30px;
        height: 30px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
        vertical-align: middle;
    }

    .upto-rate-wrap {
        position: absolute;
        top: calc(50% - 15px);
        right: 0px;
        color: $font-title-color;
        animation: uptoAni 1s infinite ease-in-out;
        background-image: var(--theme-sidebar-hot-bg);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 66px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @keyframes uptoAni {
        0% {
            transform: scale(1)
        }

        50% {
            transform: scale(1.04, 1.1)
        }

        to {
            transform: scale(1)
        }
    }

    .icon {
        ::v-deep .van-icon {
            font-size: .5rem;
            font-weight: 400;
            margin: 0 .2rem;
            vertical-align: middle;
            color: $font-accent-color;
        }

        & > img{
            width: .38rem;
            height: .38rem;
            // vertical-align: middle;
            margin: 0 .12rem;
            filter: brightness(0) saturate(100%) invert(83%) sepia(19%) saturate(846%) hue-rotate(325deg) brightness(101%) contrast(91%);

            &.imgAct{
                display: none;
            }
        }
    }

    &.act,
    &:hover {
        background: var(--theme-sidebar-item-active-bg);
        color: $font-title-color;

        &::before{
            content: '';
            width: .08rem;
            height: 52px;
            background: var(--theme-sidebar-item-active-line);
            background-size: 100% 100%;
            position: absolute;
            left: -.1rem;
            top: 0;
        }
        .icon {
            & > img{
                display: none;
                &.imgAct{
                    display: block;
                    filter: brightness(0) invert(1);
                }
            }
        }
    }
}

@media screen and (min-width: 768px) {
    .Opend {
        width: 300px;
        border-right: 1px solid var(--theme-divider);
        background: var(--theme-sidebar-bg);
    }

    .Opend_top .Opend_top_inset {
        padding: 16px 12px 0;
    }

    .share_box,
    .theme_select,
    .userMoneyInfo {
        border: 1px solid var(--theme-surface-border);
        border-radius: 5px;
        background: var(--theme-header-control-bg);
        box-shadow: none;
    }

    .share_box {
        margin: 0 0 12px;
    }

    .theme_select,
    .userMoneyInfo {
        margin-left: 0;
        margin-right: 0;
    }

    .menu-group {
        padding: 14px 0 !important;
    }

    .menu-item {
        height: 44px;
        margin: 0 0 4px;
        padding: 0 10px;
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 14px;

        &.act,
        &:hover {
            border-color: rgba(var(--theme-input-focus-border-rgb), .42);
            background: var(--theme-sidebar-item-active-bg);

            &::before {
                width: 3px;
                height: 100%;
                left: 0;
                border-radius: 2px;
            }
        }
    }

    .Opend_bottom {
        margin: 0 12px;
        padding: 14px 0 16px;
    }

    .Opend_bottom .sidebar_customerService > div {
        height: 54px;
        border: 1px solid var(--theme-surface-border);
        border-radius: 5px;
        background: var(--theme-header-control-bg);
    }
}
</style>
